import {z} from 'zod';

export const temperatureSchema = z.object({
  low: z.number(),
  high: z.number(),
  average: z.number(),
  median: z.number(),
});
